import { render, staticRenderFns } from "./CoursePeriod.vue?vue&type=template&id=77f6e5e1&scoped=true&"
import script from "./CoursePeriod.vue?vue&type=script&lang=js&"
export * from "./CoursePeriod.vue?vue&type=script&lang=js&"
import style0 from "./CoursePeriod.vue?vue&type=style&index=0&id=77f6e5e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f6e5e1",
  null
  
)

export default component.exports